import React from 'react';
import PropTypes from 'prop-types';

const SkeletonList = ({ wrapperClassName, itemClassName, count }) => (
  <div className={ wrapperClassName }>
    { Array.from({ length: count }, (_, index) => (
      <div key={ index } className={ itemClassName } />
    )) }
  </div>
);

SkeletonList.propTypes = {
  wrapperClassName: PropTypes.string.isRequired,
  itemClassName: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
};

const HomeSkeleton = ({ bannerVisibility = true }) => (
  <div className="home-skeleton">
    <div className="home-skeleton__main-banner" />

    <section className="home-skeleton__section">
      <div className="home-skeleton__section-title" />
      <SkeletonList
        wrapperClassName="home-skeleton__widget-sports"
        itemClassName="home-skeleton__widget-sport"
        count={ 8 }
      />
    </section>

    { bannerVisibility && (
      <section className="home-skeleton__section">
        <div className="home-skeleton__banner-row" />
      </section>
    ) }

    <section className="home-skeleton__section">
      <div className="home-skeleton__card" />
    </section>

    <section className="home-skeleton__section">
      <div className="home-skeleton__section-title" />
      <SkeletonList
        wrapperClassName="home-skeleton__widget-cards"
        itemClassName="home-skeleton__widget-card"
        count={ 6 }
      />
    </section>

    <section className="home-skeleton__section">
      <div className="home-skeleton__section-title" />
      <div className="home-skeleton__widget-row" />
    </section>

    <section className="home-skeleton__section">
      <div className="home-skeleton__section-title" />
      <div className="home-skeleton__popular-bets" />
    </section>
  </div>
);

HomeSkeleton.propTypes = {
  bannerVisibility: PropTypes.bool
};

export default HomeSkeleton;


